import { Component, Input, Output, EventEmitter } from '@angular/core';


@Component({
  selector: 'facility-codes-panel',
  templateUrl: './facility-codes.component.html',
  styleUrls: ['./facility-codes.component.css'],
})
export class FacilityCodesComponent {

  @Input() header = "";
  @Input() collapsed = false;
  @Output() collapsedChange: EventEmitter<boolean>;
  @Input() visible = false;
  @Input() items;
  @Input() yearDataDisplayed;

  // used to filter
  facilityToSearch


  constructor() {
    this.collapsedChange = new EventEmitter<boolean>();
  }

  onClick() {
    this.collapsedChange.emit(!this.collapsed);
  }
}



// WEBPACK FOOTER //
// ./src/app/profile/panels/facility-codes/facility-codes.component.ts